"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { InnerPre } from "./inner.js";
export const AddRefIfNedded = (props) => {
    const innerRef = useRef(null);
    const ref = props._ref || innerRef;
    // @ts-ignore
    return _jsx(InnerPre, { merge: props, _ref: ref });
};
